import routerOptions0 from "/workspace/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.1_db0@0.3.2_eslint@9.28.0_jiti@2.4.2_0a14fae649e68e751a02c03a787ab03b/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}